import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Button, Text, InputGroup, Input, InputRightElement, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import Pagination from 'src/components/shared/pagination/Pagination';
import Breadcrumbs from 'src/components/shared/breadcrumbs/Breadcrumbs';
import CategoriesTable from './Table';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';

import { getCategories } from 'src/store/categories/categoriesSlice';

import { Wrapper } from './Styles';

import theme from '../../global/theme';

const Categories = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const categories = useSelector(state => state.categories);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const [showCreateCategory, setShowCreateCategory] = useState(false);
  const [showUpdateCategory, setShowUpdateCategory] = useState(false);
  const [showDeleteCategory, setShowDeleteCategory] = useState(false);

  useEffect(() => {
    dispatch(getCategories({ page, query }));
  }, [dispatch, page, query]);


  return (
    <Wrapper>
      <Breadcrumbs
        currentPage={t('pages.categories.categories')}
        pages={[{ name: `${t('pages.dashboard.dashboard')}`, path: '/' }]}
      />

      {categories.error && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          <Text>{categories.error}</Text>
        </Alert>
      )}

      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" textTransform="uppercase"
            fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white" _hover={{ bg: 'red.600' }}
            onClick={() => setShowCreateCategory(true)}
          >
            {t('general.create')} +
          </Button>
        </Flex>

        <Flex marginBottom={8} justifyContent="flex-end">
          <InputGroup width="auto">
            <Input auth="auto" type="text" placeholder={t('general.search')}
              bg={theme.light} boxShadow={theme.shadow} color={theme.dark} border="none"
              onChange={(e) => setQuery(e.currentTarget.value)}
            />
            <InputRightElement color={theme.light} children={<FiIcons.FiSearch />} />
          </InputGroup>
        </Flex>
      </SimpleGrid>

      {categories.itemsCount > 0 ? (
        <CategoriesTable
          data={categories.data}
          page={page}
          handleUpdate={(el) => setShowUpdateCategory(el)}
          handleDelete={(el) => setShowDeleteCategory(el)}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200} alignItems="center"
          justifyContent="center" borderRadius={16}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {t('pages.categories.no_categories')}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={categories.itemsCount ?? 0}
          onChange={(page) => setPage(page)}
        />
      </Flex>

      {showCreateCategory && <CreateModal onClose={() => setShowCreateCategory(false)} />}
      {showUpdateCategory && <UpdateModal data={showUpdateCategory} onClose={() => setShowUpdateCategory(false)} />}
      {showDeleteCategory && <DeleteModal data={showDeleteCategory} onClose={() => setShowDeleteCategory(false)} />}
    </Wrapper>
  )
}

export default Categories